import { create } from "zustand";

export const useRouteStore = create<RouteState>((set) => ({
    route: '',
    setRoute: (route: any) => set({ route }),
    previousRoute: '',
    setPreviousRoute: (previousRoute: any) => set({ previousRoute }),
    hideBanner: '', 
    setHideBanner: (hideBanner: any) => set({ hideBanner })
}));

export interface RouteState {
    route: string;
    previousRoute: string;
    setPreviousRoute: (previousRoute:string) => void;
    hideBanner: string;
}